var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},_vm._l((_vm.responses),function(res){return (_vm.showResponsePanel())?_c('div',[_c('ResponseChip',{attrs:{"text":res.customValue || res.value,"number":res.num}})],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }